// app/javascript/controllers/syntax_highlight_controller.js
import {Controller} from "@hotwired/stimulus"
import {highlightCode} from "@37signals/lexxy"

// Connects to data-controller="syntax-highlight"
export default class extends Controller {
  connect() {
    highlightCode()
  }
}
